export const MODE_LIST = [
  {
    name: 'Accept Terms',
    children: [{
      type: 'i4proAcceptTerms',
      name: 'Accept Terms',
      icon: 'fas fa-user-check'
    }]
  },
  {
    name: 'Buttons',
    children: [{
      type: 'i4proButton',
      name: 'Button',
      icon: 'fas fa-gavel'
    },
    {
      type: 'i4proFabTransition',
      name: 'Fab Transition',
      icon: 'fas fa-tablets'
    },
    {
      type: 'i4proFloatingActionButtons',
      name: 'Floating Action Buttons',
      icon: 'fab fa-buffer'
    }
    ]
  },
  {
    name: 'Form inputs & Controls',
    children: [{
      type: 'i4proAlert',
      name: 'Alert',
      icon: 'fas fa-envelope'
    },
    {
      type: 'i4proAutocomplete',
      name: 'Auto Complete',
      icon: 'fas fa-search-plus'
    },
    {
      type: 'i4proCheckbox',
      name: 'Checkbox',
      icon: 'fas fa-check-square'
    },
    {
      type: 'i4proCombobox',
      name: 'Combobox',
      icon: 'fas fa-vote-yea'
    },
    {
      type: 'i4proDatePickerDialog',
      name: 'Date Picker Dialog',
      icon: 'fas fa-calendar-alt'
    },
    {
      type: 'i4proDatePickerMenu',
      name: 'Date Picker Menu',
      icon: 'far fa-calendar-alt'
    },
    {
      type: 'i4proFileInput',
      name: 'File Input',
      icon: 'fas fa-upload'
    },
    {
      type: 'i4proFileUploadList',
      name: 'File Upload List',
      icon: 'fas fa-cloud-download-alt'
    },
    {
      type: 'i4proGroupButtons',
      name: 'Group Buttons',
      icon: 'fab fa-buromobelexperte'
    },
    {
      type: 'i4proLabel',
      name: 'Label',
      icon: 'fas fa-paragraph'
    },
    {
      type: 'i4proPassword',
      name: 'Password',
      icon: 'fas fa-key'
    },
    {
      type: 'i4proRadioGroup',
      name: 'Radio Group',
      icon: 'far fa-dot-circle'
    },
    {
      type: 'i4proRating',
      name: 'Rating',
      icon: 'fas fa-star-half-alt'
    },
    {
      type: 'i4proSelect',
      name: 'Select',
      icon: 'fas fa-chevron-circle-down'
    },
    {
      type: 'i4proRangeSlider',
      name: 'Range Slider',
      icon: 'fas fa-sliders-h'
    },
    {
      type: 'i4proSlider',
      name: 'Slider',
      icon: 'fas fa-sort-amount-up-alt'
    },
    {
      type: 'i4proSwitch',
      name: 'Switch',
      icon: 'fas fa-toggle-on'
    },
    {
      type: 'i4proTextFieldSearch',
      name: 'Text Field Search',
      icon: 'fas fa-border-all'
    },
    {
      type: 'i4proTextField',
      name: 'Text Field',
      icon: 'fas fa-keyboard'
    },
    {
      type: 'i4proTextarea',
      name: 'Textarea',
      icon: 'fas fa-layer-group'
    },
    {
      type: 'i4proTextareaConcat',
      name: 'Textarea Concat',
      icon: 'fas fa-layer-group'
    },
    {
      type: 'i4proTimePickerDialog',
      name: 'Time Picker Dialog',
      icon: 'far fa-clock'
    },
    {
      type: 'i4proTimePickerMenu',
      name: 'Time Picker Menu',
      icon: 'fas fa-clock'
    }
    ]
  }
];

export const OTHERS_MODES = [
  {
    name: 'Accept Terms',
    children: [{
      type: 'i4proAcceptTerms',
      name: 'Accept Terms',
      icon: 'fas fa-user-check'
    }]
  },
  {
    name: 'Buttons',
    children: [{
      type: 'i4proButtonLink',
      name: 'Button Link',
      icon: 'fas fa-link'
    },
    {
      type: 'i4proFabTransition',
      name: 'Fab Transition',
      icon: 'fas fa-tablets'
    },
    {
      type: 'i4proFloatingActionButtons',
      name: 'Floating Action Buttons',
      icon: 'fab fa-buffer'
    },
    {
      type: 'i4proButton',
      name: 'Buttons',
      icon: 'fab fa-buffer'
    }
    ]
  },
  {
    name: 'Cards',
    children: [{
      type: 'i4proCard',
      name: 'Card',
      icon: 'fas fa-digital-tachograph'
    }]
  },
  {
    name: 'Carousels',
    children: [{
      type: 'i4proCarouselImage',
      name: 'Carousel Image',
      icon: 'fas fa-images'
    },
    {
      type: 'i4proCarousel',
      name: 'Carousel',
      icon: 'fab fa-slideshare'
    }
    ]
  },
  {
    name: 'Detail (master)',
    children: [{
      type: 'i4proDetailDrawer',
      name: 'Detail Drawer',
      icon: 'fas fa-door-open'
    },
    {
      type: 'i4proDetailPage',
      name: 'Detail Page',
      icon: 'fas fa-expand-arrows-alt'
    }
    ]
  },
  {
    name: 'ECM',
    children: [
      {
        type: 'i4proEcmBanner',
        name: 'ECM Banner',
        icon: 'far fa-address-card'
      },
      {
        type: 'i4proEcm',
        name: 'ECM',
        icon: 'fas fa-file-upload'
      },
      {
        type: 'i4proEcmFile',
        name: 'ECM File',
        icon: 'fas fa-file-upload'
      },
      {
        type: 'i4proEcmListDownload',
        name: 'ECM List Download',
        icon: 'fas fa-stream'
      }
    ]
  },
  {
    name: 'Graphics',
    children: [{
      type: 'i4proGraphicChartjs',
      name: 'chartjs',
      icon: 'fas fa-chart-bar'
    }]
  },
  {
    name: 'Html',
    children: [{
      type: 'i4proRenderHtml',
      name: 'Render Html',
      icon: 'far fa-file-code'
    }]
  },
  {
    name: 'Form inputs & Controls',
    children: [{
      type: 'i4proAlert',
      name: 'Alert',
      icon: 'fas fa-envelope'
    },
    {
      type: 'i4proAutocomplete',
      name: 'Auto Complete',
      icon: 'fas fa-search-plus'
    },
    {
      type: 'i4proCheckbox',
      name: 'Checkbox',
      icon: 'fas fa-check-square'
    },
    {
      type: 'i4proCombobox',
      name: 'Combobox',
      icon: 'fas fa-vote-yea'
    },
    {
      type: 'i4proDatePickerDialog',
      name: 'Date Picker Dialog',
      icon: 'fas fa-calendar-alt'
    },
    {
      type: 'i4proDatePickerMenu',
      name: 'Date Picker Menu',
      icon: 'far fa-calendar-alt'
    },
    {
      type: 'i4proFileInput',
      name: 'File Input',
      icon: 'fas fa-upload'
    },
    {
      type: 'i4proFileUploadList',
      name: 'File Upload List',
      icon: 'fas fa-cloud-download-alt'
    },
    {
      type: 'i4proGroupButtons',
      name: 'Group Buttons',
      icon: 'fab fa-buromobelexperte'
    },
    {
      type: 'i4proLabel',
      name: 'Label',
      icon: 'fas fa-paragraph'
    },
    {
      type: 'i4proPassword',
      name: 'Password',
      icon: 'fas fa-key'
    },
    {
      type: 'i4proRadioGroup',
      name: 'Radio Group',
      icon: 'far fa-dot-circle'
    },
    {
      type: 'i4proRating',
      name: 'Rating',
      icon: 'fas fa-star-half-alt'
    },
    {
      type: 'i4proSelect',
      name: 'Select',
      icon: 'fas fa-chevron-circle-down'
    },
    {
      type: 'i4proRangeSlider',
      name: 'Range Slider',
      icon: 'fas fa-sliders-h'
    },
    {
      type: 'i4proSlider',
      name: 'Slider',
      icon: 'fas fa-sort-amount-up-alt'
    },
    {
      type: 'i4proSwitch',
      name: 'Switch',
      icon: 'fas fa-toggle-on'
    },
    {
      type: 'i4proTextFieldSearch',
      name: 'Text Field Search',
      icon: 'fas fa-border-all'
    },
    {
      type: 'i4proTextField',
      name: 'Text Field',
      icon: 'fas fa-keyboard'
    },
    {
      type: 'i4proTextarea',
      name: 'Textarea',
      icon: 'fas fa-layer-group'
    },
    {
      type: 'i4proTextareaConcat',
      name: 'Textarea Concat',
      icon: 'fas fa-layer-group'
    },
    {
      type: 'i4proTimePickerDialog',
      name: 'Time Picker Dialog',
      icon: 'far fa-clock'
    },
    {
      type: 'i4proTimePickerMenu',
      name: 'Time Picker Menu',
      icon: 'fas fa-clock'
    },
    {
      type: 'i4proFlexmonster',
      name: 'Flex monster',
      icon: 'fas fa-chart-line'
    }
    ]
  },
  {
    name: 'List Email',
    children: [{
      type: 'i4proListEmail',
      name: 'List Email',
      icon: 'fas fa-envelope-open-text'
    }]
  },
  {
    name: 'markdown',
    children: [{
      type: 'i4proRenderMarkdown',
      name: 'Render Markdown',
      icon: 'far fa-file-code'
    }]
  },
  {
    name: 'Partials',
    children: [{
      type: 'i4proColumnGroup',
      name: 'Colums Group',
      icon: 'far fa-object-ungroup'
    }]
  },
  // {
  //   name: 'Steps',
  //   children: [
  //     { type: 'i4proHorizontalStep', name: 'Horizontal', icon: 'fas fa-ruler-horizontal' },
  //     { type: 'i4proVerticalStep', name: 'Vertical', icon: 'fas fa-ruler-vertical' }
  //   ]
  // },
  {
    name: 'Tables',
    children: [{
      type: 'i4proTableGenerator',
      name: 'Table Generator',
      icon: 'fas fa-solar-panel'
    },
    {
      type: 'i4proTableDetail',
      name: 'Table Detail',
      icon: 'fas fa-solar-panel'
    }
    ]
  },
  {
    name: 'Tabs',
    children: [{
      type: 'i4proTabs',
      name: 'Tab',
      icon: 'fas fa-tasks'
    }]
  },
  {
    name: 'Title',
    children: [{
      type: 'i4proTitle',
      name: 'Title',
      icon: 'fas fa-heading'
    },
    {
      type: 'i4proTitleDescription',
      name: 'Title Description',
      icon: 'fas fa-heading'
    }]
  }
];

export const CONFIG_LAYOUT = [
  {
    type: 'i4proHeader',
    name: 'Header',
    locationObject: 'header',
    icon: 'fas fa-ruler-horizontal'
  },
  {
    type: 'i4proBreadcrumbs',
    name: 'Breadcrumbs',
    locationObject: 'breadcrumbs',
    icon: 'fas fa-map-signs'
  },
  {
    type: 'i4proLogo',
    name: 'Logo',
    locationObject: 'header',
    locationSubObject: 'logo',
    icon: 'fas fa-file-image',
  },
  {
    type: 'i4proMenu',
    name: 'Menu',
    locationObject: 'menu',
    icon: 'fas fa-list-alt'
  },
  {
    type: 'i4proConfig',
    name: 'Config',
    locationObject: 'config',
    icon: 'fas fa-cogs'
  },
  {
    type: 'i4proTheme',
    name: 'Theme',
    locationObject: 'theme',
    icon: 'fas fa-palette'
  },
  {
    type: 'i4proSidebar',
    name: 'Sidebar',
    locationObject: 'sidebar',
    icon: 'fas fa-ruler-vertical'
  },
  {
    type: 'i4proFooter',
    name: 'Footer',
    locationObject: 'footer',
    icon: 'fa-money-check'
  },
  {
    type: 'i4proProgressbar',
    name: 'Progressbar',
    locationObject: 'loading',
    icon: 'fas fa-spinner'
  },
  {
    type: 'i4proLogin',
    name: 'Login',
    locationObject: 'login',
    icon: 'fas fa-unlock-alt'
  },
  {
    type: 'i4proRecaptcha',
    locationObject: 'login',
    locationSubObject: 'recaptcha',
    name: 'Recaptcha',
    icon: 'fas fa-user-lock'
  },
  {
    type: 'i4proDialogs',
    name: 'Dialogs',
    locationObject: 'dialogs',
    icon: 'far fa-window-restore'
  },
  {
    type: 'i4proPaths',
    name: 'Paths',
    locationObject: 'paths',
    icon: 'far fa-images'
  }
]
